import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificationService} from '../../../services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import EMAIL_REGEX from '../../../validators/regex/email.regex';
import {UserService} from '../../../services/user.service';
import {Location} from '@angular/common';

@Component({templateUrl: './add-second-user.component.html'})
export class AddSecondUserComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  clientId: number;
  isLoading: boolean;
  usernameAvailable = true;

  constructor(private builder: FormBuilder,
              private service: UserService,
              private notificationService: NotificationService,
              private router: Router,
              private _location: Location,
              private route: ActivatedRoute) {
    window.scrollTo(0, 0);
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {
    this.form = this.getForm();
    this.route.params.subscribe(params => this.clientId = params['clientId']);
  }

  submit(value) {
    this.submitted = true;
    if (this.form.invalid || this.isLoading || !this.usernameAvailable) {
      return;
    }
    this.isLoading = true;
    this.service.addSecondUser(this.clientId, value).subscribe(() => {
        this.notificationService.success('tweede bewindvoerder toegevoegd');
        this.router.navigate(['/']);
      }, error => this.notificationService.errorResponse(error),
      () => this.isLoading = false);
  }

  checkForEmail($event: Event) {
    const email = ($event.target as HTMLInputElement).value;
    if (email.match(EMAIL_REGEX)) {
      this.service.isUsernameAvailable(email).subscribe(res => this.usernameAvailable = res.usernameAvailable);
    } else {
      this.usernameAvailable = true;
    }
  }

  private getForm() {
    return this.builder.group({
      'username': ['', [Validators.required, Validators.pattern(EMAIL_REGEX), Validators.maxLength(255)]],
      'showEmailOnReports': [false],
      'firstNameInitials': ['', [Validators.required, Validators.maxLength(255)]],
      'firstName': ['', [Validators.required, Validators.maxLength(255)]],
      'insertion': ['', [Validators.maxLength(255)]],
      'lastName': ['', [Validators.required, Validators.maxLength(255)]],
      'street': ['', [Validators.required, Validators.maxLength(255)]],
      'houseNumber': ['', [Validators.required, Validators.maxLength(255)]],
      'houseNumberSuffix': ['', [Validators.maxLength(255)]],
      'zipCode': ['', [Validators.required, Validators.maxLength(255)]],
      'city': ['', [Validators.required, Validators.maxLength(255)]],
      'phone': ['', [Validators.required, Validators.maxLength(255)]],
    });
  }
}
